'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import RetakePracticalExerciseModal from './RetakePracticalExerciseModal';
import UsageTracker from '../../../utils/UsageTracker';
import { TrackingContentTypes } from '../../../constants/Tracking';
import { RequiredProductNames } from '../../../constants/CourseConstants';
import { useDeletePracticalExerciseProgress } from '../';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class PracticalExerciseRetryButtonContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayRetakeModal: false
    };
    this.handleRejectRetakePracticalExercise = this.handleRejectRetakePracticalExercise.bind(this);
    this.handleClickRetakeExercise = this.handleClickRetakeExercise.bind(this);
    this.handleConfirmRetakePracticalExercise = this.handleConfirmRetakePracticalExercise.bind(this);
  }
  handleClickRetakeExercise() {
    this.setState({
      displayRetakeModal: true
    });
  }
  handleRejectRetakePracticalExercise() {
    this.setState({
      displayRetakeModal: false
    });
  }
  handleConfirmRetakePracticalExercise() {
    const {
      trackId,
      lessonId,
      contentId
    } = this.props;
    this.setState({
      displayRetakeModal: false
    });
    UsageTracker.track('contentInteraction', {
      action: 'retry-practical-exercise',
      contentId,
      contentType: TrackingContentTypes.PRACTICAL_EXERCISE_FLOW,
      trackId,
      lessonId
    });
    this.props.onRetryPracticalExercise(Number(contentId));
  }
  render() {
    const {
      requiredAccess,
      requiredProduct,
      use
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      className: this.props.className,
      children: [this.state.displayRetakeModal && /*#__PURE__*/_jsx(RetakePracticalExerciseModal, {
        onConfirm: this.handleConfirmRetakePracticalExercise,
        onReject: this.handleRejectRetakePracticalExercise
      }), /*#__PURE__*/_jsx(UITooltip, {
        disabled: !(requiredProduct || requiredAccess),
        headingText: requiredProduct ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.practicalExercise.requiredProduct.${requiredProduct}.header`
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.practicalExercise.requiredAccess.${requiredAccess}.header`
        }),
        title: requiredProduct ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.practicalExercise.requiredProduct.${requiredProduct}.description`
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.practicalExercise.requiredAccess.${requiredAccess}.description`
        }),
        children: /*#__PURE__*/_jsx(UIButton, {
          "data-test-id": "practical-exercise-retry-button",
          disabled: !!requiredProduct || !!requiredAccess,
          onClick: this.handleClickRetakeExercise,
          use: use,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practicalExercise.retake"
          })
        })
      })]
    });
  }
}
PracticalExerciseRetryButtonContainer.propTypes = {
  className: PropTypes.string,
  // we use this prop in mapDispatchToProps
  contentId: PropTypes.string.isRequired,
  lessonId: PropTypes.string.isRequired,
  onRetryPracticalExercise: PropTypes.func.isRequired,
  requiredAccess: PropTypes.oneOf(Object.keys(RequiredProductNames)),
  requiredProduct: PropTypes.oneOf(Object.keys(RequiredProductNames)),
  trackId: PropTypes.string,
  use: PropTypes.string
};
PracticalExerciseRetryButtonContainer.defaultProps = {
  use: 'secondary'
};
const PracticalExerciseRetryButtonFunctionalContainer = props => {
  const [deletePracticalExerciseProgress] = useDeletePracticalExerciseProgress();
  return /*#__PURE__*/_jsx(PracticalExerciseRetryButtonContainer, Object.assign({
    onRetryPracticalExercise: deletePracticalExerciseProgress
  }, props));
};
export default PracticalExerciseRetryButtonFunctionalContainer;